module.exports = __webpack_public_path__ + "static/media/web logos_Cisco.98abdc21.jpg";